import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

function Header() {
  const { isAuthenticated, currentUser, logout, hasJournaledToday, streak } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  return (
    <header className="app-header">
      <div className="header-content">
        <Link to="/" className="logo">
          <div className="logo-icon" />
          <span>ZenLog</span>
        </Link>
        <nav className="main-nav">
          {isAuthenticated ? (
            <>
              <div className={`journal-status ${hasJournaledToday ? 'status-positive' : 'status-negative'}`}>
                {`Hi, ${currentUser?.first_name || 'friend'}! ${hasJournaledToday ? "You've journaled today!" : "You have not journaled today."}`}
              </div>
              <div className="streak-counter status-neutral">
                <span>📅</span>
                <span>{streak}</span>
              </div>
              <Link to="/dashboard">Dashboard</Link>
              <Link to="/analytics">Analytics</Link>
              <button onClick={handleLogout} className="btn btn-danger">
                Log Out
              </button>
            </>
          ) : (
            <>
              <Link to="/signin">Sign In</Link>
              <Link to="/signup" className="btn btn-confirm">
                Sign Up
              </Link>
            </>
          )}
        </nav>
      </div>
    </header>
  );
}

export default Header;

